'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { cn } from '../../utils/cn';
import { NavbarContext } from './Context';
const Navbar = forwardRef(({ children, className, ...props }, ref) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen((prev) => !prev);
    return (_jsx("header", { ref: ref, ...props, className: cn('relative rounded-lg border border-metal-100 bg-white py-5 dark:border-metal-900 dark:bg-metal-900', className), children: _jsx(NavbarContext.Provider, { value: { open, handleOpen }, children: children }) }));
});
Navbar.displayName = 'Navbar';
export { Navbar };
